import { TextField, Box, Typography } from "@mui/material";
import MoedaInput from "../../../../util/ui/inputs/moedaInput";

type Props = {
  outros: number;
  outrosCustos: number;
  valorLiquido: number;
};

export default function ResumoNegocios({
  outros,
  outrosCustos,
  valorLiquido,
}: Props) {
  return (
    <Box
      display={"flex"}
      flexDirection="column"
      width="100%"
      paddingX={1}
      paddingY={2}
    >
      {/* Section header do sistema: eyebrow mono tracked sobre hairline. */}
      <Box
        borderBottom={1}
        borderColor="divider"
        paddingBottom={1}
        marginBottom={1.5}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Resumo dos negócios
        </Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Outros
          </Typography>
        </Box>
        <TextField
          id="standard-outros"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          disabled
          variant="outlined"
          value={outros}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Outros Custos
          </Typography>
        </Box>
        <TextField
          id="standard-outrosCustos"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          disabled
          variant="outlined"
          value={outrosCustos}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      {/* Subtotal: separado por hairline e com o número em mono peso 500. */}
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        borderTop={1}
        borderColor="divider"
        marginTop={1.5}
        paddingTop={1.5}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.primary">
            Valor Líquido
          </Typography>
        </Box>
        <TextField
          id="standard-valorLiquido"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          disabled
          variant="outlined"
          value={valorLiquido}
          sx={{ "& input": { fontWeight: 500 } }}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
    </Box>
  );
}
